<template>
  <header class="estat-index-header">
    <div class="estat-index-header-top">
      <div class="estat-index-title-row">
        <Icon :name="icon" class="estat-index-icon" aria-hidden="true" />
        <h1 class="estat-index-title">{{ title }}</h1>
      </div>
      <div v-if="$slots.actions" class="estat-index-header-actions"><slot name="actions" /></div>
    </div>
    <p v-if="description" class="estat-index-description">{{ description }}</p>
    <div v-else-if="$slots.default" class="estat-index-description"><slot /></div>
  </header>
</template>

<script>
import Icon from '@/Shared/Icon'

export default {
  components: { Icon },
  props: {
    title: { type: String, required: true },
    icon: { type: String, default: 'dashboard' },
    description: { type: String, default: '' },
  },
}
</script>

<style scoped>
.estat-index-header { margin: 0 0 28px; padding: 0; }
.estat-index-header .estat-index-header-top { display: flex; align-items: center; justify-content: space-between; gap: 20px; }
.estat-index-header .estat-index-title-row { display: flex; align-items: center; gap: 14px; min-width: 0; }
.estat-index-header .estat-index-title {
  margin: 0; padding: 0; font-family: inherit; font-size: 26px;
  font-weight: 700; line-height: 1.35; letter-spacing: -.5px; color: #006483;
}
.estat-index-header .estat-index-icon { display: block; width: 32px; height: 32px; flex: 0 0 32px; color: #006483; fill: currentColor; }
.estat-index-header .estat-index-icon :deep(path) { fill: currentColor; }
.estat-index-header .estat-index-description {
  margin: 16px 0 0; padding: 0; font-family: inherit; font-size: 16px;
  font-weight: 400; line-height: 1.7; letter-spacing: normal; color: #344767;
}
.estat-index-header-actions { display: flex; flex-wrap: wrap; gap: 12px; flex-shrink: 0; }
@media (max-width: 640px) {
  .estat-index-header .estat-index-header-top { align-items: flex-start; flex-direction: column; gap: 16px; }
  .estat-index-header .estat-index-title { font-size: 23px; }
  .estat-index-header .estat-index-title-row { gap: 12px; }
  .estat-index-header .estat-index-icon { width: 28px; height: 28px; flex-basis: 28px; }
}
</style>
